@use '../../styling/colors.scss' as *;
@use '../../styling/form-controls.scss' as *;
@use '../../styling/typography.scss' as *;

.Timezone {
  @extend %form-control-font;

  font-size: $font-size-normal;
  display: grid;
  grid-template-columns: auto auto;
  gap: 8px;
  align-items: center;
  width: fit-content;

  path {
    color: $theme-color-text;
  }
}
